import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/**
 * Bordered like the controls beside it, so it reads as part of the period rather than as a setting.
 * Its own height matches the band's fields exactly — nothing here is taller than anything else, which
 * is what lets the band wrap without moving a neighbour half a line.
 */
export const wrapperSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    height: '2rem',
    pl: 1.25,
    pr: 0.5,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.neutral[200]}`,
    backgroundColor: theme.palette.common.white,
};

export const captionSx: SxProps<Theme> = {
    fontSize: '0.6875rem',
    color: theme.palette.neutral[600],
    whiteSpace: 'nowrap',
};

export const trackSx: SxProps<Theme> = {
    display: 'flex',
    gap: '2px',
    py: '4px',
};

const baseOptionSx: Record<string, unknown> = {
    appearance: 'none',
    border: 0,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '0.6875rem',
    lineHeight: '24px',
    padding: '0 9px',
    borderRadius: '5px',
    whiteSpace: 'nowrap',
    '&:disabled': {
        cursor: 'default',
        opacity: 0.6,
    },
};

export const optionSx: SxProps<Theme> = {
    ...baseOptionSx,
    fontWeight: 500,
    color: theme.palette.neutral[600],
    backgroundColor: 'transparent',
    '&:hover:not(:disabled)': {
        color: theme.palette.neutral[800],
    },
};

export const selectedOptionSx: SxProps<Theme> = {
    ...baseOptionSx,
    fontWeight: 600,
    color: theme.palette.primaryColor[600],
    backgroundColor: theme.palette.primaryColor[50],
};

export const hintSx: SxProps<Theme> = {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.neutral[500],
    pr: 0.5,
};

export const iconSx: SxProps<Theme> = {
    fontSize: 15,
};
